import type { ReactNode } from 'react';
import { Text } from '@savvy-kit/foundations/text';

type IconRowButtonProps = {
  readonly icon: ReactNode;
  readonly title: string;
  readonly onClick: () => void;
};

export default function IconRowButton({ icon, title, onClick }: IconRowButtonProps) {
  return (
    <div className="flex flex-1 cursor-pointer -mx-2 rounded-lg px-2 py-2 hover:bg-component-hover" onClick={onClick}>
      <div className="flex self-center pr-4">{icon}</div>
      <div className="flex flex-col justify-center">
        <Text>{title}</Text>
      </div>
    </div>
  );
}
